import httpClient from './httpClient';

const BASE_URL = '/n2n';

export const fetchGroupCodes = () => {
  return httpClient.get(`${BASE_URL}/groupcode`);
};

export const createGroupCode = payload => {
  return httpClient.post(`${BASE_URL}/groupcode`, payload);
};

export const updateGroupCode = (groupid, payload) => {
  return httpClient.put(`${BASE_URL}/groupcode/${groupid}`, payload);
};

export const deleteGroupCode = groupid => {
  return httpClient.delete(`${BASE_URL}/groupcode/${groupid}`);
};

export const retryFailedMarket = marketid => {
  return httpClient.put(`${BASE_URL}/marketlist/retry`, { marketid });
};

export const fetchMarketList = params => {
  return httpClient.get(`${BASE_URL}/marketlist`, { params });
};

export const saveMarketList = payload => {
  return httpClient.post(`${BASE_URL}/marketlist`, payload);
};

export const deleteMarkets = (marketIds, options = {}) => {
  const payload = { marketIds };
  if (typeof options.permanent === 'boolean') {
    payload.permanent = options.permanent;
  }
  return httpClient.delete(`${BASE_URL}/marketlist`, {
    data: payload
  });
};

export const fetchPendingProductList = params => {
  return httpClient.get(`${BASE_URL}/productlist`, { params });
};

export const updatePendingProductStatus = payload => {
  return httpClient.post(`${BASE_URL}/productlist`, payload);
};

const REGISTER_BASE = `${BASE_URL}/register`;

export const fetchRegisterBasicInfo = () => {
  return httpClient.get(`${REGISTER_BASE}/basicinfo`);
};

export const searchRegisterProducts = params => {
  return httpClient.get(`${REGISTER_BASE}/search`, { params });
};

export const fetchRegisterDetail = productid => {
  return httpClient.get(`${REGISTER_BASE}/detail-info`, { params: { productid } });
};

export const postRegisterPriceChange = payload => {
  return httpClient.post(`${REGISTER_BASE}/`, payload);
};

export const putRegisterPriceChange = payload => {
  return httpClient.put(`${REGISTER_BASE}/price-change`, payload);
};

export const postRegisterIpConfirm = payload => {
  return httpClient.post(`${REGISTER_BASE}/ip-confirm`, payload);
};

export const deleteRegisterProducts = productids => {
  return httpClient.delete(`${REGISTER_BASE}/`, { data: { productids } });
};

export const postN2nRemoval = productids => {
  return httpClient.post(`${BASE_URL}/removal`, { productids });
};

export const fetchRemovalSetting = () => {
  return httpClient.get(`${BASE_URL}/removal-setting`);
};

export const updateRemovalSetting = payload => {
  return httpClient.put(`${BASE_URL}/removal-setting`, payload);
};

// N2N Catalog
export const fetchCatalog = params => {
  return httpClient.get(`${BASE_URL}/catalog`, { params });
};

export const updateCatalog = payload => {
  return httpClient.post(`${BASE_URL}/catalog`, payload);
};

